/**
 * BaseService
 * Abstract base class for all SDK services
 * Handles URL construction, service path configuration, and endpoint overrides
 */
/**
 * Abstract base service class
 * Provides URL construction and endpoint management for microservice routing
 */
export class BaseService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config.servicePath;
        this.basePath = config.basePath;
        this.endpointOverrides = config.endpoints ?? {};
    }
    /**
     * Get the endpoint path, checking for overrides
     * @param key - The endpoint key (used for override lookup)
     * @param defaultPath - The default endpoint path
     * @returns The resolved endpoint path
     */
    getEndpoint(key, defaultPath) {
        return this.endpointOverrides[key] ?? defaultPath;
    }
    /**
     * Build the full URL path for an endpoint
     * Combines service path and base path with the endpoint
     *
     * URL Pattern: /{servicePath}/{basePath}/{endpoint}
     * Example: /task/api/task/list-view
     *
     * @param endpoint - The endpoint path (can be empty for base path)
     * @returns The full URL path
     */
    buildUrl(endpoint) {
        const parts = [];
        // Add service path if configured (for microservice routing)
        if (this.servicePath) {
            parts.push(this.servicePath);
        }
        // Add base path
        parts.push(this.basePath);
        // Add endpoint if provided
        if (endpoint) {
            parts.push(endpoint);
        }
        // Join with '/' and ensure leading slash
        const url = '/' + parts.join('/').replace(/\/+/g, '/').replace(/^\//, '');
        console.log('[BaseService] buildUrl - servicePath:', this.servicePath, 'basePath:', this.basePath, 'endpoint:', endpoint, '-> URL:', url);
        return url;
    }
    /**
     * Build URL with query parameters
     * @param endpoint - The endpoint path
     * @param params - Query parameters object
     * @returns The full URL path with query string
     */
    buildUrlWithParams(endpoint, params) {
        const url = this.buildUrl(endpoint);
        if (!params) {
            return url;
        }
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        return queryString ? `${url}?${queryString}` : url;
    }
}
//# sourceMappingURL=BaseService.js.map